/**
 * Customer Details Page
 * Displays detailed customer information
 */

import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CustomerDetails from '../components/CustomerDetails';

export default function CustomerDetailsPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isDeletedView = searchParams.get('view') === 'deleted';

  return (
    <div className="bg-gray-50 dark:bg-gray-900">
      {/* Back Button */}
      <div className="mb-6" style={{ marginLeft: '18px' }}>
        <button
          onClick={() => navigate(isDeletedView ? '/customers?view=deleted' : '/customers')}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:text-gray-100"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Customers
        </button>
      </div>

      {/* Customer Details Component */}
      {id ? (
        <CustomerDetails customerId={id} isDeletedView={isDeletedView} />
      ) : (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <p className="text-red-700">Customer ID is required</p>
        </div>
      )}
    </div>
  );
}
